import { useEffect, useState } from "react";
import { Music, X, ChevronDown } from "lucide-react";
import { http } from "@/lib/api";

export const toEmbed = (url) => {
  if (!url) return null;
  const sp = url.match(/open\.spotify\.com\/(?:intl-[a-z]+\/)?(playlist|album)\/([A-Za-z0-9]+)/);
  if (sp) return { src: `https://open.spotify.com/embed/${sp[1]}/${sp[2]}?theme=0`, height: 352 };
  const yt = url.match(/[?&]list=([A-Za-z0-9_-]+)/);
  if (yt) return { src: `https://www.youtube.com/embed/videoseries?list=${yt[1]}`, height: 220 };
  return null;
};

export const PLAYLIST_EVENT = "lz:playlist";

export const MusicPlayer = () => {
  const [url, setUrl] = useState("");
  const [open, setOpen] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    http.get("/settings/playlist").then((r) => setUrl(r.data?.url ?? "")).catch(() => {});
    const onChange = (e) => setUrl(e.detail ?? "");
    window.addEventListener(PLAYLIST_EVENT, onChange);
    return () => window.removeEventListener(PLAYLIST_EVENT, onChange);
  }, []);

  const embed = toEmbed(url);
  if (!embed) return null;
  return (
    <div className="fixed left-3 bottom-3 sm:left-5 sm:bottom-5 z-[70]" data-testid="music-player">
      <div className={`${open ? "block" : "hidden"} mb-2 w-[min(360px,calc(100vw-1.5rem))] rounded-2xl overflow-hidden border border-purple-200/25 bg-[#170a24] shadow-2xl`}>
        <div className="flex items-center justify-between px-3 py-2">
          <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-amber-200">Hollow radio</span>
          <button onClick={() => setOpen(false)} aria-label="Hide player" data-testid="music-hide-btn" className="p-1 text-purple-200 hover:text-white">
            <ChevronDown className="w-4 h-4" />
          </button>
        </div>
        {mounted && (
          <iframe title="Lavender Hollow playlist" src={embed.src} width="100%" height={embed.height} loading="lazy"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" className="block border-0"
            data-testid="music-iframe" />
        )}
      </div>
      <button onClick={() => { setMounted(true); setOpen((o) => !o); }} data-testid="music-toggle-btn"
        aria-label={open ? "Hide music" : "Play music"}
        className="flex items-center gap-2 rounded-full bg-purple-100 text-[#0e0616] pl-3 pr-4 py-2.5 text-sm font-medium shadow-xl hover:bg-amber-200 transition-colors">
        {open ? <X className="w-4 h-4" /> : <Music className="w-4 h-4" />} {open ? "Close" : "Music"}
      </button>
    </div>
  );
};
